export const BusinessModels = {
  Credit: "Credit",
  License: "License",
} as const;

export const CompanyTiers = {
  Free: "free",
  Paid: "paid",
  Enterprise: "enterprise",
} as const;
